module.exports = __webpack_public_path__ + "static/img/logo.534e6d9e.svg";